import React from 'react';
import MetaTags from '../MetaTags';
import striptags from 'striptags';

const ProductMetas = ({ product }) => {
  // Return early if there is no product
  if (!product) return null;

  const images = product.images ?? [];

  const headDescription =
    product.head.metaTags.find(({ name }) => name === 'description')?.content ||
    '';
  const headKeywords =
    product.head.metaTags.find(({ name }) => name === 'keywords')?.content ||
    '';

  const ogTitle = product.customFields.find(field => field.key === 'og_title')
    ?.stringValue;
  const ogDescription = product.customFields.find(
    field => field.key === 'og_description'
  )?.stringValue;
  const ogImageUrl = product.customFields.find(
    field => field.key === 'og_image'
  )?.stringValue;

  return (
    <MetaTags
      title={product.head.title || product.name}
      imageUrl={images.length > 0 ? images[0].url : null}
      description={
        headDescription
          ? striptags(headDescription)
          : striptags(product.description)
      }
      keywords={headKeywords}
      canonicalPath={product.primaryRoute.canonicalPath}
      ogTitle={ogTitle}
      ogDescription={ogDescription}
      ogImageUrl={ogImageUrl}
    />
  );
};

export default ProductMetas;
